import type { ArticleModule } from 'types/capi/article';

export type ModulePositions = Map<ArticleModule, number>;

export function getModulePositions(modules: ArticleModule[]): ModulePositions {
  const positions: ModulePositions = new Map();
  let next = 1;

  const visit = (module: ArticleModule) => {
    positions.set(module, next++);

    if (module.type !== 'module-row') return;

    module.columns?.forEach((column) =>
      column.modules?.forEach((childModule) => visit(childModule))
    );
  };

  modules.forEach(visit);

  return positions;
}
